/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { computed } from 'vue';
import { usePrefixClass } from '../hooks/useConfig.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-bfb23a5e.mjs';
import '../_chunks/dep-a48de419.mjs';
import '../_chunks/dep-2a7dc5c7.mjs';
import '../_chunks/dep-9311bf66.mjs';
import '../_chunks/dep-4889eb51.mjs';
import '../_chunks/dep-0b4185fe.mjs';
import '../_chunks/dep-3ca5fb38.mjs';
import '../_chunks/dep-7071345f.mjs';
import '../_chunks/dep-d2403b2f.mjs';
import '../_chunks/dep-7922050a.mjs';
import '../_chunks/dep-169ea640.mjs';
import '../_chunks/dep-f6b25712.mjs';
import '../_chunks/dep-59545a4d.mjs';
import '../_chunks/dep-c27b1c14.mjs';
import '../_chunks/dep-7d96367f.mjs';
import '../_chunks/dep-827c4600.mjs';
import '../_chunks/dep-0820e0e2.mjs';
import '../_chunks/dep-caad2e91.mjs';
import '../_chunks/dep-3d4aad09.mjs';
import '../_chunks/dep-8e38f523.mjs';
import '../_chunks/dep-469bf54b.mjs';
import '../_chunks/dep-8ef9fb8e.mjs';
import '../_chunks/dep-e769aafd.mjs';
import '../_chunks/dep-400798c5.mjs';
import '../_chunks/dep-361522ee.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../config-provider/type.mjs';

var useCLASSNAMES = function useCLASSNAMES() {
  var classPrefix = usePrefixClass();
  return computed(function () {
    var tree = "".concat(classPrefix.value, "-tree");
    return {
      icon: "".concat(classPrefix.value, "-icon"),
      folderIcon: "".concat(classPrefix.value, "-folder-icon"),
      actived: "".concat(classPrefix.value, "-is-active"),
      disabled: "".concat(classPrefix.value, "-is-disabled"),
      treeIconRight: "".concat(classPrefix.value, "-icon-arrow-right"),
      treeIconDown: "".concat(classPrefix.value, "-icon-arrow-down"),
      treeNodeToggle: "".concat(classPrefix.value, "-tree-toggle"),
      tree: tree,
      treeTransition: "".concat(tree, "--transition"),
      treeBlockNode: "".concat(tree, "--block-node"),
      treeEmpty: "".concat(tree, "__empty"),
      treeList: "".concat(tree, "__list"),
      treeNode: "".concat(tree, "__item"),
      treeNodeOpen: "".concat(tree, "__item--open"),
      treeHoverAble: "".concat(tree, "--hoverable"),
      treeCheckable: "".concat(tree, "--checkable"),
      treeLabel: "".concat(tree, "__label"),
      treeLabelStrictly: "".concat(tree, "__label--strictly"),
      treeIcon: "".concat(tree, "__icon"),
      treeIconDefault: "".concat(tree, "__icon--default"),
      treeSpace: "".concat(tree, "__space"),
      treeOperations: "".concat(tree, "__operations"),
      treeNodeVisible: "".concat(tree, "__item--visible"),
      treeNodeHidden: "".concat(tree, "__item--hidden"),
      treeNodeEnter: "".concat(tree, "__item--enter-active"),
      treeNodeLeave: "".concat(tree, "__item--leave-active"),
      treeNodeDraggable: "".concat(tree, "__item--draggable"),
      treeNodeDragging: "".concat(tree, "__item--dragging"),
      treeNodeDragTipTop: "".concat(tree, "__item--tip-top"),
      treeNodeDragTipBottom: "".concat(tree, "__item--tip-bottom"),
      treeNodeDragTipHighlight: "".concat(tree, "__item--tip-highlight"),
      line: "".concat(tree, "__line"),
      lineIsLeaf: "".concat(tree, "__line--leaf"),
      lineIsFirst: "".concat(tree, "__line--first")
    };
  });
};
var injectKey = Symbol("treeProvider");
var dragInjectKey = Symbol("onDrag");

export { dragInjectKey, injectKey, useCLASSNAMES };
//# sourceMappingURL=constants.mjs.map
